module.exports = __webpack_public_path__ + "static/media/bills.d6a54522.png";